(function () {
  "use strict";

  /*
  ==========================================
  QUESS 360 WIPE/KIT PAIRING
  ==========================================
  */

  const SAMPLING_KIT_VARIANT_ID =
    "59924630339665";

  const ANALYSIS_VARIANT_IDS = new Set([
    // HD Wipe Sampling
    "59915026432081",
    "59915026464849",
    "59915026497617",
    "59915026530385",
    "59915026563153",
    "59915026595921",

    // Hormone Wipe Sampling
    "59924571619409",
    "59924571652177",
    "59924571684945"
  ]);

  const shopRoot =
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";

  const NOTICE_KEY =
    "quess360_pairing_notice";

  let checkInProgress = false;
  let scheduledCheck = null;


  /*
  ==========================================
  CART API
  ==========================================
  */

  async function getCart() {
    const response = await fetch(
      shopRoot + "cart.js",
      {
        method: "GET",
        headers: {
          Accept: "application/json"
        },
        cache: "no-store"
      }
    );

    if (!response.ok) {
      throw new Error(
        "Unable to read the Shopify cart."
      );
    }

    return response.json();
  }


  async function addSamplingKit() {
    const response = await fetch(
      shopRoot + "cart/add.js",
      {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },

        body: JSON.stringify({
          items: [
            {
              id: Number(
                SAMPLING_KIT_VARIANT_ID
              ),

              quantity: 1,

              properties: {
                "Kit type":
                  "Regular Sampling Kit",

                "_builder_item":
                  "sampling-kit",

                "_required_for":
                  "HD or hormone wipe sampling"
              }
            }
          ]
        })
      }
    );

    const result = await response
      .json()
      .catch(function () {
        return {};
      });

    if (!response.ok) {
      throw new Error(
        result.description ||
        result.message ||
        "The required sampling kit could not be added."
      );
    }

    return result;
  }


  async function updateCartLines(updates) {
    const response = await fetch(
      shopRoot + "cart/update.js",
      {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },

        body: JSON.stringify({
          updates: updates
        })
      }
    );

    const result = await response
      .json()
      .catch(function () {
        return {};
      });

    if (!response.ok) {
      throw new Error(
        result.description ||
        result.message ||
        "The cart could not be corrected."
      );
    }

    return result;
  }


  /*
  ==========================================
  CART LINE DETECTION
  ==========================================
  */

  function isAnalysisLine(item) {
    return ANALYSIS_VARIANT_IDS.has(
      String(item.variant_id)
    );
  }


  function isSamplingKitLine(item) {
    return (
      String(item.variant_id) ===
      SAMPLING_KIT_VARIANT_ID
    );
  }


  /*
  ==========================================
  CUSTOMER NOTICE
  ==========================================
  */

  function saveNotice(message) {
    try {
      sessionStorage.setItem(
        NOTICE_KEY,
        message
      );
    } catch (error) {
      console.warn(
        "QUESS notice storage error:",
        error
      );
    }
  }


  function showSavedNotice() {
    let message = "";

    try {
      message =
        sessionStorage.getItem(
          NOTICE_KEY
        ) || "";

      sessionStorage.removeItem(
        NOTICE_KEY
      );
    } catch (error) {
      return;
    }

    if (!message) return;

    const notice =
      document.createElement("div");

    notice.id =
      "quess360-pairing-notice";

    notice.setAttribute(
      "role",
      "status"
    );

    notice.textContent =
      message;

    notice.style.position =
      "fixed";

    notice.style.left =
      "50%";

    notice.style.bottom =
      "25px";

    notice.style.transform =
      "translateX(-50%)";

    notice.style.zIndex =
      "999999";

    notice.style.width =
      "min(calc(100% - 30px), 650px)";

    notice.style.padding =
      "16px 20px";

    notice.style.borderRadius =
      "14px";

    notice.style.background =
      "#263442";

    notice.style.color =
      "#ffffff";

    notice.style.fontSize =
      "14px";

    notice.style.lineHeight =
      "1.5";

    notice.style.textAlign =
      "center";

    notice.style.boxShadow =
      "0 12px 35px rgba(0, 0, 0, .22)";

    document.body.appendChild(
      notice
    );

    window.setTimeout(
      function () {
        notice.remove();
      },
      6000
    );
  }


  /*
  ==========================================
  PAIRING RULE
  ==========================================
  */

  async function enforceProductPairing() {
    if (checkInProgress) {
      return false;
    }

    checkInProgress = true;

    try {
      const cart =
        await getCart();

      const analysisLines =
        cart.items.filter(
          isAnalysisLine
        );

      const samplingKitLines =
        cart.items.filter(
          isSamplingKitLine
        );

      const hasAnalysis =
        analysisLines.length > 0;

      const hasSamplingKit =
        samplingKitLines.length > 0;


      /*
      Analysis without required kit:
      restore the kit.
      */

      if (
        hasAnalysis &&
        !hasSamplingKit
      ) {
        await addSamplingKit();

        saveNotice(
          "The sampling kit is required with HD or hormone wipe sampling and has been restored to your cart."
        );

        window.location.reload();

        return true;
      }


      /*
      Kit without analysis:
      remove the kit.
      */

      if (
        !hasAnalysis &&
        hasSamplingKit
      ) {
        const updates = {};

        samplingKitLines.forEach(
          function (line) {
            updates[line.key] = 0;
          }
        );

        await updateCartLines(
          updates
        );

        saveNotice(
          "The sampling kit was removed because no HD or hormone wipe sampling remains in your cart."
        );

        window.location.reload();

        return true;
      }


      /*
      Analysis and kit are both present,
      but there is more than one kit.
      Keep exactly one.
      */

      if (
        hasAnalysis &&
        hasSamplingKit
      ) {
        const totalKitQuantity =
          samplingKitLines.reduce(
            function (total, line) {
              return (
                total +
                Number(line.quantity)
              );
            },
            0
          );

        if (
          samplingKitLines.length > 1 ||
          totalKitQuantity !== 1
        ) {
          const updates = {};

          samplingKitLines.forEach(
            function (line, index) {
              updates[line.key] =
                index === 0 ? 1 : 0;
            }
          );

          await updateCartLines(
            updates
          );

          saveNotice(
            "Only one sampling kit is required per order. Your cart has been corrected."
          );

          window.location.reload();

          return true;
        }
      }

      return false;
    } catch (error) {
      console.error(
        "QUESS 360 pairing error:",
        error
      );

      return false;
    } finally {
      checkInProgress = false;
    }
  }


  /*
  ==========================================
  SCHEDULE CHECK
  ==========================================
  */

  function schedulePairingCheck(delay) {
    window.clearTimeout(
      scheduledCheck
    );

    scheduledCheck =
      window.setTimeout(
        function () {
          enforceProductPairing();
        },
        typeof delay === "number"
          ? delay
          : 500
      );
  }


  /*
  ==========================================
  WATCH CART INTERACTIONS
  ==========================================
  */

  const cartAreaSelector = [
    "cart-drawer",
    "cart-items",
    "cart-remove-button",
    "[id*='CartDrawer']",
    "[id*='cart-drawer']",
    "[data-cart-drawer]",
    "[data-cart-items]",
    "form[action*='/cart']",
    ".cart",
    ".cart-drawer"
  ].join(",");


  document.addEventListener(
    "click",
    function (event) {
      const target =
        event.target instanceof Element
          ? event.target
          : null;

      if (!target) return;

      if (
        target.closest(
          cartAreaSelector
        )
      ) {
        schedulePairingCheck(800);
      }
    },
    true
  );


  document.addEventListener(
    "change",
    function (event) {
      const target =
        event.target instanceof Element
          ? event.target
          : null;

      if (!target) return;

      if (
        target.closest(
          cartAreaSelector
        )
      ) {
        schedulePairingCheck(800);
      }
    },
    true
  );


  /*
  Shopify standard/theme cart events.
  */

  [
    "cart:update",
    "cart:updated",
    "cart:refresh",
    "cart:change",
    "product:added",
    "ajaxProduct:added"
  ].forEach(function (eventName) {
    document.addEventListener(
      eventName,
      function () {
        schedulePairingCheck(350);
      },
      true
    );
  });


  /*
  Watch cart drawer or cart section HTML
  being replaced by the theme.
  */

  const observer =
    new MutationObserver(
      function (mutations) {
        const cartWasChanged =
          mutations.some(
            function (mutation) {
              const target =
                mutation.target &&
                mutation.target.nodeType === 1
                  ? mutation.target
                  : mutation.target.parentElement;

              if (
                target &&
                target.closest &&
                target.closest(
                  cartAreaSelector
                )
              ) {
                return true;
              }

              return Array.from(
                mutation.addedNodes
              ).some(function (node) {
                return (
                  node.nodeType === 1 &&
                  (
                    node.matches?.(
                      cartAreaSelector
                    ) ||
                    node.querySelector?.(
                      cartAreaSelector
                    )
                  )
                );
              });
            }
          );

        if (cartWasChanged) {
          schedulePairingCheck(500);
        }
      }
    );


  /*
  ==========================================
  INITIALIZATION
  ==========================================
  */

  function initializePairing() {
    console.info(
      "QUESS 360 pairing script loaded."
    );

    showSavedNotice();

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

    schedulePairingCheck(300);


    /*
    Extra safety on the full cart page.
    */

    if (
      window.location.pathname
        .toLowerCase()
        .includes("/cart")
    ) {
      window.setInterval(
        function () {
          if (
            document.visibilityState ===
            "visible"
          ) {
            enforceProductPairing();
          }
        },
        1500
      );
    }
  }


  /*
  Manual diagnostic functions.
  */

  window.quessPairingCheck =
    enforceProductPairing;

  window.quessPairingDebug =
    async function () {
      const cart =
        await getCart();

      const analysisLines =
        cart.items.filter(
          isAnalysisLine
        );

      const samplingKitLines =
        cart.items.filter(
          isSamplingKitLine
        );

      console.log(
        "QUESS pairing debug:",
        {
          cart: cart,
          analysisLines:
            analysisLines,
          samplingKitLines:
            samplingKitLines
        }
      );

      return {
        cart: cart,
        analysisLines:
          analysisLines,
        samplingKitLines:
          samplingKitLines
      };
    };


  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      initializePairing
    );
  } else {
    initializePairing();
  }


  window.addEventListener(
    "pageshow",
    function () {
      schedulePairingCheck(300);
    }
  );

  /*
=========================================
QUESS MINIMUM WIPE SAMPLE QUANTITY
=========================================

Rules:

- The physical sampling kit remains quantity 1.
- Analysis variants must total at least 3 samples.
- Multiple analysis groups may share that total.
*/

(function () {
  if (window.__quessMinimumSamplesLoaded) {
    return;
  }

  window.__quessMinimumSamplesLoaded = true;


  const MINIMUM_SAMPLES = 3;


  /*
  Analysis variant IDs only.

  Do not include the Regular Sampling Kit
  variant in this list.
  */

  const ANALYSIS_VARIANT_IDS =
    new Set([
      /*
      Hazardous drug groups
      */

      "59915026432081", // Group 1F
      "59915026464849", // Group 1M
      "59915026497617", // Group 2
      "59915026530385", // Group 3
      "59915026563153", // Group 4
      "59915026595921", // Group 5

      /*
      Hormone analyses
      */

      "59924571619409", // 1 hormone
      "59924571652177", // 3 hormones
      "59924571684945"  // 5 hormones
    ]);


  const nativeFetch =
    window.fetch.bind(window);


  const shopifyRoot =
    (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    )
      ? window.Shopify.routes.root
      : "/";


  let currentCart = null;
  let correctionRunning = false;
  let minimumCheckTimer = null;


  function getCartRoute(
    path
  ) {
    return `${shopifyRoot}${path}`
      .replace(/\/{2,}/g, "/");
  }


  function isAnalysisItem(
    item
  ) {
    return ANALYSIS_VARIANT_IDS.has(
      String(item.variant_id)
    );
  }


  function getAnalysisItems(
    cart
  ) {
    if (
      !cart ||
      !Array.isArray(cart.items)
    ) {
      return [];
    }

    return cart.items.filter(
      isAnalysisItem
    );
  }


  function getAnalysisTotal(
    cart
  ) {
    return getAnalysisItems(cart)
      .reduce(
        function (
          total,
          item
        ) {
          return (
            total +
            Number(item.quantity || 0)
          );
        },
        0
      );
  }


  async function getCurrentCart() {
    const response =
      await nativeFetch(
        getCartRoute("cart.js"),
        {
          method: "GET",
          credentials: "same-origin",
          headers: {
            "Accept":
              "application/json"
          }
        }
      );


    if (!response.ok) {
      throw new Error(
        "The Shopify cart could not be loaded."
      );
    }


    return response.json();
  }


  async function updateCartLine(
    lineKey,
    quantity
  ) {
    const response =
      await nativeFetch(
        getCartRoute(
          "cart/change.js"
        ),
        {
          method: "POST",

          credentials:
            "same-origin",

          headers: {
            "Content-Type":
              "application/json",

            "Accept":
              "application/json"
          },

          body:
            JSON.stringify({
              id:
                lineKey,

              quantity:
                quantity
            })
        }
      );


    if (!response.ok) {
      throw new Error(
        "The sampling quantity could not be corrected."
      );
    }


    return response.json();
  }


  function createMinimumNotice() {
  let overlay =
    document.getElementById(
      "quess-minimum-samples-overlay"
    );


  if (overlay) {
    return overlay;
  }


  const style =
    document.createElement(
      "style"
    );


  style.textContent = `
    #quess-minimum-samples-overlay {
      position: fixed;
      inset: 0;
      z-index: 999999;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 24px;
      background: rgba(20, 42, 56, 0.58);
      backdrop-filter: blur(3px);
      -webkit-backdrop-filter: blur(3px);
      opacity: 0;
      visibility: hidden;
      transition:
        opacity 70ms ease,
        visibility 70ms ease;
    }

    #quess-minimum-samples-overlay.is-visible {
      opacity: 1;
      visibility: visible;
    }

    #quess-minimum-samples-modal {
      width: 100%;
      max-width: 480px;
      padding: 32px;
      border: 1px solid rgba(0, 104, 165, 0.25);
      border-radius: 18px;
      background: #ffffff;
      color: #263844;
      box-shadow:
        0 24px 70px
        rgba(0, 0, 0, 0.25);
      text-align: center;
      transform: translateY(12px) scale(0.98);
      transition:
        transform 70ms ease;
    }

    #quess-minimum-samples-overlay.is-visible
    #quess-minimum-samples-modal {
      transform: translateY(0) scale(1);
    }

    .quess-minimum-modal-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 58px;
      height: 58px;
      margin: 0 auto 18px;
      border-radius: 50%;
      background: rgba(0, 104, 165, 0.1);
      color: #0068a5;
      font-size: 30px;
      font-weight: 700;
    }

    #quess-minimum-samples-title {
      margin: 0 0 12px;
      color: #263844;
      font-size: 24px;
      line-height: 1.25;
      font-weight: 700;
    }

    #quess-minimum-samples-description {
      margin: 0;
      color: #536875;
      font-size: 16px;
      line-height: 1.6;
    }

    #quess-minimum-samples-description strong {
      color: #0068a5;
    }

    #quess-minimum-samples-ok {
      width: 100%;
      margin-top: 26px;
      padding: 13px 24px;
      border: 1px solid #0068a5;
      border-radius: 10px;
      background: #0068a5;
      color: #ffffff;
      font-family: inherit;
      font-size: 16px;
      font-weight: 700;
      cursor: pointer;
      transition:
        background 160ms ease,
        transform 160ms ease;
    }

    #quess-minimum-samples-ok:hover {
      background: #00578b;
    }

    #quess-minimum-samples-ok:active {
      transform: scale(0.98);
    }

    #quess-minimum-samples-ok:focus-visible {
      outline: 3px solid rgba(0, 104, 165, 0.3);
      outline-offset: 3px;
    }

    body.quess-modal-open {
      overflow: hidden;
    }

    @media screen and (max-width: 540px) {
      #quess-minimum-samples-modal {
        padding: 26px 22px;
        border-radius: 15px;
      }

      #quess-minimum-samples-title {
        font-size: 21px;
      }
    }
  `;


  document.head.appendChild(
    style
  );


  overlay =
    document.createElement(
      "div"
    );


  overlay.id =
    "quess-minimum-samples-overlay";


  overlay.innerHTML = `
    <div
      id="quess-minimum-samples-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="quess-minimum-samples-title"
      aria-describedby="quess-minimum-samples-description"
    >
      <div
        class="quess-minimum-modal-icon"
        aria-hidden="true"
      >
        !
      </div>

      <h2 id="quess-minimum-samples-title">
        Minimum quantity required
      </h2>

      <p id="quess-minimum-samples-description">
        A minimum of
        <strong>3 wipe samples</strong>
        is required for each sampling order.
        Please keep the total sample quantity
        at 3 or more.
      </p>

      <button
        id="quess-minimum-samples-ok"
        type="button"
      >
        OK
      </button>
    </div>
  `;


  document.body.appendChild(
    overlay
  );


  const okButton =
    overlay.querySelector(
      "#quess-minimum-samples-ok"
    );


  okButton.addEventListener(
    "click",
    function () {
      overlay.classList.remove(
        "is-visible"
      );

      document.body.classList.remove(
        "quess-modal-open"
      );
    }
  );


  return overlay;
}


function showMinimumNotice() {
  const overlay =
    createMinimumNotice();


  overlay.classList.add(
    "is-visible"
  );


  document.body.classList.add(
    "quess-modal-open"
  );


  const okButton =
    overlay.querySelector(
      "#quess-minimum-samples-ok"
    );


  window.requestAnimationFrame(
  function () {
    okButton?.focus();
    }
    );
}


  function findLineItemForInput(
    input,
    cart,
    fallbackIndex
  ) {
    const variantId =
      input.getAttribute(
        "data-quantity-variant-id"
      ) ||
      input.getAttribute(
        "data-variant-id"
      );


    if (variantId) {
      const variantMatch =
        cart.items.find(
          function (
            item
          ) {
            return (
              String(
                item.variant_id
              ) ===
              String(
                variantId
              )
            );
          }
        );


      if (variantMatch) {
        return variantMatch;
      }
    }


    const explicitIndex =
      Number(
        input.getAttribute(
          "data-index"
        ) ||
        input.getAttribute(
          "data-line"
        ) ||
        input.getAttribute(
          "data-cart-item-index"
        )
      );


    if (
      Number.isInteger(
        explicitIndex
      ) &&
      explicitIndex > 0
    ) {
      return (
        cart.items[
          explicitIndex - 1
        ] || null
      );
    }


    const idMatch =
      String(
        input.id || ""
      ).match(
        /(\d+)$/
      );


    if (idMatch) {
      const idIndex =
        Number(
          idMatch[1]
        );


      if (
        idIndex > 0 &&
        cart.items[
          idIndex - 1
        ]
      ) {
        return cart.items[
          idIndex - 1
        ];
      }
    }


    return (
      cart.items[
        fallbackIndex
      ] || null
    );
  }


  function applyMinimumsToInputs(cart) {
    const analysisTotal =
      getAnalysisTotal(
        cart
      );


    const inputs =
      Array.from(
        document.querySelectorAll(
          [
            'input[name="updates[]"]',
            'input[name^="updates["]',
            "input[data-quantity-variant-id]"
          ].join(",")
        )
      );


    inputs.forEach(
      function (
        input,
        index
      ) {
        const item =
          findLineItemForInput(
            input,
            cart,
            index
          );


        if (
          !item ||
          !isAnalysisItem(item)
        ) {
          input.removeAttribute(
            "data-quess-analysis"
          );

          input.removeAttribute(
            "data-quess-minimum"
          );

          input.removeAttribute(
            "data-quess-line-key"
          );

          return;
        }


        /*
        Calculate how low this individual
        line may go while keeping the total
        analysis quantity at 3.
        */

        const otherAnalysisQuantity =
          analysisTotal -
          Number(
            item.quantity || 0
          );


        const minimumForThisLine =
          Math.max(
            0,
            MINIMUM_SAMPLES -
              otherAnalysisQuantity
          );


        input.setAttribute(
          "min",
          String(
            minimumForThisLine
          )
        );


        input.setAttribute(
          "data-quess-analysis",
          "true"
        );


        input.setAttribute(
          "data-quess-minimum",
          String(
            minimumForThisLine
          )
        );


        input.setAttribute(
          "data-quess-line-key",
          item.key
        );


        input.setAttribute(
          "data-quess-cart-quantity",
          String(
            item.quantity
          )
        );


        const quantityWrapper =
          input.closest(
            [
              "quantity-input",
              ".quantity",
              "[data-quantity-selector]",
              ".cart-item__quantity"
            ].join(",")
          ) ||
          input.parentElement;


        if (!quantityWrapper) {
          return;
        }


        const minusButton =
          quantityWrapper.querySelector(
            [
              'button[name="minus"]',
              "[data-quantity-minus]",
              ".quantity__button--minus"
            ].join(",")
          );


        if (!minusButton) {
          return;
        }


        const currentQuantity =
          Number(
            input.value
          );


        const shouldDisable =
  currentQuantity <=
  minimumForThisLine;


/*
Keep the button clickable so the modal
can appear, but mark it as blocked.
*/

minusButton.disabled = false;

minusButton.removeAttribute(
  "disabled"
);

minusButton.setAttribute(
  "aria-disabled",
  shouldDisable
    ? "true"
    : "false"
);

minusButton.classList.toggle(
  "quess-minimum-blocked",
  shouldDisable
);
      }
    );
  }


  async function enforceMinimumSamples() {
    if (correctionRunning) {
      return;
    }


    try {
      const cart =
        await getCurrentCart();


      currentCart =
        cart;


      applyMinimumsToInputs(
        cart
      );


      const analysisItems =
        getAnalysisItems(
          cart
        );


      const analysisTotal =
        getAnalysisTotal(
          cart
        );


      /*
      A total of zero means that the whole
      analysis configuration was removed.

      The existing pairing script can then
      handle the physical sampling kit.
      */

      if (
        analysisTotal === 0 ||
        analysisTotal >=
          MINIMUM_SAMPLES
      ) {
        return;
      }


      correctionRunning =
        true;


      /*
      Someone bypassed the visible control
      and created a total of 1 or 2.

      Restore the missing quantity onto the
      first remaining analysis line.
      */

      const missingQuantity =
        MINIMUM_SAMPLES -
        analysisTotal;


      const correctionTarget =
        analysisItems[0];


      await updateCartLine(
        correctionTarget.key,

        Number(
          correctionTarget.quantity
        ) +
          missingQuantity
      );


      sessionStorage.setItem(
        "quess_minimum_samples_corrected",
        "true"
      );


      window.location.reload();
    }


    catch (error) {
      console.error(
        "QUESS minimum quantity error:",
        error
      );
    }


    finally {
      correctionRunning =
        false;
    }
  }


  function scheduleMinimumCheck(
    delay
  ) {
    window.clearTimeout(
      minimumCheckTimer
    );


    minimumCheckTimer =
      window.setTimeout(
        enforceMinimumSamples,
        delay || 150
      );
  }


  function isCartMutationRequest(
    request
  ) {
    try {
      const requestUrl =
        typeof request ===
          "string"
          ? request
          : request.url;


      const pathname =
        new URL(
          requestUrl,
          window.location.origin
        ).pathname;


      return (
        /\/cart\/(?:add|change|update|clear)(?:\.js)?$/.test(
          pathname
        )
      );
    }


    catch (error) {
      return false;
    }
  }


  /*
  Watch Shopify Ajax cart changes.

  The original fetch response is still
  returned to the theme normally.
  */

  window.fetch =
    async function (
      ...argumentsList
    ) {
      const response =
        await nativeFetch(
          ...argumentsList
        );


      if (
        isCartMutationRequest(
          argumentsList[0]
        )
      ) {
        scheduleMinimumCheck(
          200
        );


        window.setTimeout(
          enforceMinimumSamples,
          750
        );
      }


      return response;
    };


  /*
  Stop the visible minus button when the
  line is already at its calculated
  minimum.
  */

  document.addEventListener(
    "click",

    function (
      event
    ) {
      if (
        !(
          event.target
          instanceof Element
        )
      ) {
        return;
      }


      const minusButton =
        event.target.closest(
          [
            'button[name="minus"]',
            "[data-quantity-minus]",
            ".quantity__button--minus"
          ].join(",")
        );


      if (!minusButton) {
        return;
      }


      const quantityWrapper =
        minusButton.closest(
          [
            "quantity-input",
            ".quantity",
            "[data-quantity-selector]",
            ".cart-item__quantity"
          ].join(",")
        );


      const input =
        quantityWrapper
          ?.querySelector(
            [
              'input[name="updates[]"]',
              'input[name^="updates["]',
              "input[data-quantity-variant-id]"
            ].join(",")
          );


      if (
        !input ||
        input.getAttribute(
          "data-quess-analysis"
        ) !== "true"
      ) {
        return;
      }


      const currentQuantity =
        Number(
          input.value
        );


      const minimumQuantity =
        Number(
          input.getAttribute(
            "data-quess-minimum"
          )
        );


      if (
        Number.isFinite(
          minimumQuantity
        ) &&
        currentQuantity <=
          minimumQuantity
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();

        showMinimumNotice();
      }
    },

    true
  );


  /*
  Stop a customer from manually typing a
  quantity below the calculated minimum.
  */

  document.addEventListener(
    "change",

    function (
      event
    ) {
      if (
        !(
          event.target
          instanceof HTMLInputElement
        )
      ) {
        return;
      }


      const input =
        event.target;


      if (
        input.getAttribute(
          "data-quess-analysis"
        ) !== "true"
      ) {
        return;
      }


      const submittedQuantity =
        Number(
          input.value
        );


      const minimumQuantity =
        Number(
          input.getAttribute(
            "data-quess-minimum"
          )
        );


      if (
        !Number.isFinite(
          minimumQuantity
        ) ||
        submittedQuantity >=
          minimumQuantity
      ) {
        return;
      }


      event.preventDefault();
      event.stopImmediatePropagation();


      input.value =
        String(
          minimumQuantity
        );


      showMinimumNotice();


      const lineKey =
        input.getAttribute(
          "data-quess-line-key"
        );


      if (lineKey) {
        updateCartLine(
          lineKey,
          minimumQuantity
        )
          .then(
            function () {
              window.location.reload();
            }
          )
          .catch(
            function (
              error
            ) {
              console.error(
                "QUESS quantity update error:",
                error
              );

              scheduleMinimumCheck(
                0
              );
            }
          );
      }
    },

    true
  );

  /*
=========================================
SHOW MINIMUM MODAL IMMEDIATELY
=========================================
*/

function handleBlockedMinimumAttempt(
  event
) {
  if (
    !(
      event.target
      instanceof Element
    )
  ) {
    return;
  }


  const blockedButton =
    event.target.closest(
      ".quess-minimum-blocked"
    );


  if (!blockedButton) {
    return;
  }


  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();


  /*
  Show the modal immediately when the
  customer presses the minus button.
  */

  if (
    event.type === "pointerdown" ||
    event.type === "keydown"
  ) {
    showMinimumNotice();
  }
}


/*
Mouse, trackpad and touchscreen.
*/

document.addEventListener(
  "pointerdown",
  handleBlockedMinimumAttempt,
  true
);


/*
Block the later Shopify click event.
*/

document.addEventListener(
  "click",
  handleBlockedMinimumAttempt,
  true
);


/*
Keyboard accessibility.
*/

document.addEventListener(
  "keydown",

  function (
    event
  ) {
    if (
      event.key !== "Enter" &&
      event.key !== " "
    ) {
      return;
    }


    handleBlockedMinimumAttempt(
      event
    );
  },

  true
);

  /*
  Prevent checkout if an invalid quantity
  somehow exists before the page has been
  corrected.
  */

  document.addEventListener(
    "click",

    function (
      event
    ) {
      if (
        !(
          event.target
          instanceof Element
        )
      ) {
        return;
      }


      const checkoutControl =
        event.target.closest(
          [
            'button[name="checkout"]',
            'input[name="checkout"]',
            'a[href*="/checkout"]'
          ].join(",")
        );


      if (
        !checkoutControl ||
        !currentCart
      ) {
        return;
      }


      const total =
        getAnalysisTotal(
          currentCart
        );


      if (
        total > 0 &&
        total <
          MINIMUM_SAMPLES
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();

        showMinimumNotice();
        scheduleMinimumCheck(
          0
        );
      }
    },

    true
  );


  function initializeMinimumValidation() {
  /*
  Build the hidden modal during page load
  so it does not need to be created after
  the customer clicks the minus button.
  */

  createMinimumNotice();
    const correctionMessage =
      sessionStorage.getItem(
        "quess_minimum_samples_corrected"
      );


    if (
      correctionMessage ===
      "true"
    ) {
      sessionStorage.removeItem(
        "quess_minimum_samples_corrected"
      );


      showMinimumNotice();
    }


    enforceMinimumSamples();
  }


  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      initializeMinimumValidation
    );
  }


  else {
    initializeMinimumValidation();
  }


  window.addEventListener(
    "pageshow",
    enforceMinimumSamples
  );
})();
})();